import { getI18n } from '@/helpers/i18n';
import PlanungsgeschaeftIndex from '@/views/PlanungsgeschaefteRoot.vue';
import PlanungsgeschaeftOverview from '@/views/PlanungsgeschaefteOverview.vue';
import PlanungsgeschaeftMyPlanungsgeschaefteList from '@/views/MeinePlanungsgeschaefteList.vue';
import PlanungsgeschaeftEditView from '@/views/PlanungsgeschaeftEditView.vue';
import PlanungsgeschaeftEditDashboard from '@/views/PlanungsgeschaeftEditDashboard.vue';
import PlanungsgeschaeftEditEditor from '@/views/PlanungsgeschaeftEditEditor.vue';
import PlanungsgeschaeftEditEditorAllgemeineAngaben from '@/views/PlanungsgeschaeftEditEditorAllgemeineAngaben.vue';
import PlanungsgeschaeftEditEditorBeteiligte from '@/views/PlanungsgeschaeftEditEditorBeteiligte.vue';
import PlanungsgeschaeftEditEditorPlaene from '@/views/PlanungsgeschaeftEditEditorPlaene.vue';
import PlanungsgeschaeftEditEditorWeitereUnterlagen from '@/views/PlanungsgeschaeftEditEditorWeitereUnterlagen.vue';
import PlanungsgeschaeftEditEditorAnmerkungen from '@/views/PlanungsgeschaeftEditEditorAnmerkungen.vue';
import PlanungsgeschaeftEditEditorAbschluss from '@/views/PlanungsgeschaeftEditEditorAbschluss.vue';
import PlanungsgeschaeftCreate from '@/views/PlanungsgeschaeftCreate.vue';
import PlanungsgeschaeftEditEch from '@/views/PlanungsgeschaeftEditEch.vue';
import PlanungsgeschaeftEditAccess from '@/views/PlanungsgeschaeftEditAccess.vue';
// import PlanungsgeschaeftEditEditorZustimmungDritter from '@/views/PlanungsgeschaeftEditEditorZustimmungDritter.vue';
import PlanungsgeschaeftEditDokumente from '@/views/PlanungsgeschaeftEditDokumente.vue';
// import PlanungsgeschaeftCreate from '@/views/PlanungsgeschaeftCreate.vue';

export default [
    {
        path: '/geschaefte',
        name: 'geschaefte',
        component: PlanungsgeschaeftIndex,
        meta: {
            guest: true,
            title: () => getI18n().t('planungsgeschaefte'),
            breadcrumbTitle: () => getI18n().t('planungsgeschaefte'),
            breadcrumbTo: { name: 'planungsgeschaefte-overview' }
        },
        children: [
            {
                path: 'new',
                name: 'planungsgeschaefte-create',
                component: PlanungsgeschaeftCreate,
                meta: {
                    guest: false,
                    title: () => getI18n().t('new_geschaeft'),
                    skipBreadcrumb: true
                }
            },
            {
                path: '',
                name: 'planungsgeschaefte-overview',
                component: PlanungsgeschaeftOverview,
                meta: {
                    guest: true,
                    title: () => getI18n().t('overview'),
                    skipBreadcrumb: true
                }
            },
            {
                path: 'meine_geschaefte',
                meta: {
                    guest: true,
                    skipBreadcrumb: true,
                    breadcrumbTitle: () => getI18n().t('geschaeft_erfassen')
                },
                children: [
                    {
                        path: '',
                        name: 'planungsgeschaefte-my-geschaefte',
                        component: PlanungsgeschaeftMyPlanungsgeschaefteList,
                        meta: {
                            guest: true,
                            title: () => getI18n().t('meine_geschaefte'),
                            breadcrumbTitle: () => getI18n().t('meine_geschaefte')
                        }
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'planungsgeschaeft-edit',
                        alias: '/:id(\\d+)',
                        component: PlanungsgeschaeftEditView,
                        meta: {
                            requiresAuth: true,
                            title: () => getI18n().t('eingabe'),
                            breadcrumbTitle: () => getI18n().t('eingabe'),
                            breadcrumbTo: { name: 'planungsgeschaeft-edit-dashboard' },
                            allowScrollAnchors: true
                        },
                        children: [
                            {
                                path: '',
                                component: PlanungsgeschaeftEditDashboard,
                                name: 'planungsgeschaeft-edit-dashboard',
                                meta: {
                                    requiresAuth: true,
                                    title: () => getI18n().t('dashboard'),
                                    breadcrumbTitle: () => getI18n().t('dashboard')
                                }
                            },
                            {
                                path: '',
                                name: 'planungsgeschaeft-edit-editor-root',
                                component: PlanungsgeschaeftEditEditor,
                                meta: {
                                    requiresAuth: true,
                                    title: () => getI18n().t('editor'),
                                    breadcrumbTo: { name: 'planungsgeschaeft-edit-editor' },
                                    skipBreadcrumb: true
                                },
                                children: [
                                    {
                                        path: 'allgemein',
                                        name: 'planungsgeschaeft-edit-editor',
                                        component: PlanungsgeschaeftEditEditorAllgemeineAngaben,
                                        meta: {
                                            requiresAuth: true,
                                            title: () => getI18n().t('allgemeine_angaben'),
                                            breadcrumbTitle: () => getI18n().t('allgemeine_angaben')
                                        }
                                    },
                                    {
                                        path: 'beteiligte',
                                        name: 'planungsgeschaeft-edit-beteiligte',
                                        component: PlanungsgeschaeftEditEditorBeteiligte,
                                        meta: {
                                            requiresAuth: true,
                                            title: () => getI18n().t('beteiligte'),
                                            breadcrumbTitle: () => getI18n().t('beteiligte')
                                        }
                                    },
                                    {
                                        path: 'plaene',
                                        name: 'planungsgeschaeft-edit-plaene',
                                        component: PlanungsgeschaeftEditEditorPlaene,
                                        meta: {
                                            requiresAuth: true,
                                            title: () => getI18n().t('berichte_plaene_vorschriften'),
                                            breadcrumbTitle: () => getI18n().t('documents')
                                        }
                                    },
                                    {
                                        path: 'weitere_unterlagen',
                                        name: 'planungsgeschaeft-edit-weitere-unterlagen',
                                        component: PlanungsgeschaeftEditEditorWeitereUnterlagen,
                                        meta: {
                                            requiresAuth: true,
                                            title: () => getI18n().t('weitere_unterlagen'),
                                            breadcrumbTitle: () => getI18n().t('weitere_unterlagen')
                                        }
                                    },
                                    {
                                        path: 'anmerkungen',
                                        name: 'planungsgeschaeft-edit-anmerkungen',
                                        component: PlanungsgeschaeftEditEditorAnmerkungen,
                                        meta: {
                                            requiresAuth: true,
                                            title: () => getI18n().t('anmerkungen'),
                                            breadcrumbTitle: () => getI18n().t('anmerkungen')
                                        }
                                    },
                                    {
                                        path: 'abschluss',
                                        name: 'planungsgeschaeft-edit-abschluss',
                                        component: PlanungsgeschaeftEditEditorAbschluss,
                                        meta: {
                                            requiresAuth: true,
                                            title: () => getI18n().t('abschluss'),
                                            breadcrumbTitle: () => getI18n().t('abschluss')
                                        }
                                    }
                                ]
                            },
                            {
                                path: '',
                                component: PlanungsgeschaeftEditDokumente,
                                name: 'planungsgeschaeft-edit-documents',
                                meta: {
                                    requiresAuth: true,
                                    title: () => getI18n().t('documents'),
                                    breadcrumbTitle: () => getI18n().t('documents')
                                }
                            },
                            {
                                path: 'berechtigungen',
                                component: PlanungsgeschaeftEditAccess,
                                name: 'planungsgeschaeft-edit-access',
                                meta: {
                                    requiresAuth: true,
                                    title: () => getI18n().t('berechtigungen'),
                                    breadcrumbTitle: () => getI18n().t('berechtigungen')
                                }
                            },
                            {
                                path: 'nachrichten',
                                name: 'planungsgeschaeft-edit-ech',
                                component: PlanungsgeschaeftEditEch,
                                meta: {
                                    requiresAuth: true,
                                    title: () => getI18n().t('messages')
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
